<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Topics
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'TopicCreate'}">
          <button class="btn btn-success">Create New Topic</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="topics" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'TopicEdit', params: {id: props.row.id}}">
              <span
                class="btn btn-warning btn-sm m-1"
                data-toggle="tooltip"
                title="Edit"
                :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Topics",
  data() {
    return {
      topics: [],
      columns: ["id", "name", "description", "created_at","category.name","language","weight","questions_count","action"],
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getTopics();
  },
  methods: {
    getTopics() {
      this.$axios
        .get(`${ADMIN_URL}/topics`)
        .then((response) => {
          console.log("topics, response === ", response.data);
          this.topics = response.data.topic_list;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteTopic(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteTopic(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/topics/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getTopics()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>

<!--
<template>
  <div class="animated fadeIn">
    <div class="cardheading">
      <h4><i class="fa fa-file-image-o"></i><span class="ml-1">Categories</span></h4>
      <div class="">
        <h1 class="my-auto tableName">

        </h1>
      </div>
      <div class="">
        <router-link :to="{ name: 'CategoryCreate'}">
          <button class="btn btn-success">Create New Category</button>
        </router-link>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-card>
          <v-client-table :data="category" :columns="columns" :options="options">
            <template slot="image" slot-scope="props">
              <div class="center-div">
                <img :src="`${BASE_URL}/${src_image}${props.row.image}`" style="width: 160px;height: 90px;">
              </div>
            </template>
            <template slot="action" slot-scope="props">
              <div>
                <router-link :to="{ name: 'Category / Edit', params: { id: props.row.id }}"><span class="btn btn-warning btn-sm m-1" data-toggle="tooltip" title="Edit" :href="props.row.id">
                                    <i class="fa fa-edit"></i></span></router-link>
                <span class="btn btn-danger btn-sm m-1" data-toggle="tooltip" title="Delete"> <i class="fa fa-trash"></i></span>
              </div>
            </template>
          </v-client-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
  import axios from 'axios';
  const BASE_URL  = process.env.VUE_APP_BASE_URL;

  export default {
    name: 'Categories',
    data() {
      return {
        BASE_URL: BASE_URL,
        category : [],
        src_image : 'images/categories/',
        columns: ['image', 'title', 'service', 'type', 'status', 'created_at', 'action'],
        options: {
          pagination: {nav: 'fixed'},
          filterByColumn: true,
          toMomentFormat: 'YYYY-MM-DD',
          sortIcon: {base: 'fa fa-sort', up: 'fa fa-sort-up', down: 'fa fa-sort-down', is: 'fa fa-sort'},

        }

      }
    },
    created(){
      const Admin_URL = process.env.VUE_APP_ADMIN_URL;
      const BASE_URL  = process.env.VUE_APP_BASE_URL;
      axios.get(`${Admin_URL}/categories`)
              .then(response => {
                // console.log('B2CSections.vue, response === ', response.data);
                this.category = response.data;
              })
              .catch(e=>{
                //console.log("error occurs");
              });
    },
    methods: {

    },
  }
</script>
-->
